import React, { Component } from 'react';
import OgaSelect from "../elements/OgaSelect";

import { connect } from 'react-redux';

import { fetchYearsTerm } from 'reducers/project/projectActions'

class TermYearsSelect extends Component {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.fetchYearsTerm(this.props.project.value);
    }

    handleChange = (yearTerm) => {
        this.props.handleChange(yearTerm);
    }

    render() {        
        return (
            <OgaSelect
                disabled={this.props.disabled}
                bsSize="small"
                placeholder="Cantidad de años a pagar"
                value={this.props.selection}
                onChange={(yearTerm) => this.handleChange(yearTerm)}
                options={this.props.yearsTerm}
            />
        )
    }
}

const mapStateToProps = state => ({
    yearsTerm: state.project.yearsTerm
});

export default connect(mapStateToProps, { fetchYearsTerm })(TermYearsSelect);



// WEBPACK FOOTER //
// ./src/components/TermYearsSelect/TermYearsSelect.jsx